import z from 'zod';

export const CustomerLabelKind = z.literal(['IsSuspicious', 'PendingBasketCheck']);
export type CustomerLabelKind = z.infer<typeof CustomerLabelKind>;

export const CustomerLabelMetadata = z.object({
    dsiSession: z.string().nullish(),
});
export type CustomerLabelMetadata = z.infer<typeof CustomerLabelMetadata>;

export const CustomerLabel = z.object({
    label: CustomerLabelKind,
    metadata: CustomerLabelMetadata,
    createdOn: z.coerce.date(),
    modifiedOn: z.coerce.date(),
    modifiedBy: z.string().nullish(),
    deletedOn: z.coerce.date().nullish(),
});
export type CustomerLabel = z.infer<typeof CustomerLabel>;
